import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Axios from "axios";
import Link from "@material-ui/core/Link";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Divider from "@material-ui/core/Divider";
import moment from "moment";

import AttendanceIcon from "../../../../Assets/Logo/AttendanceIcon.svg";
import { url } from "../../../../Config/Config";
import { useStyles } from "./DashboardAttendance.css";
import CustomTableHeader from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";

class DashboardAttendance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      staffColumn: [
        { name: "Staff Name" },
        { name: "Department" },
        { name: "Status" },
      ],
      studentColumn: [
        { name: "Student Name" },
        { name: "Class" },
        { name: "Section" },
        { name: "Status" },
      ],
      studentAttendance: [],
      staffAttendance: [],
    };
  }

  componentDidMount() {
    this.getAttendances();
  }

  getAttendances = async () => {
    try {
      const response = await Axios.get(`${url}/api/staff-attendance`, {
        params: { date: moment(new Date()).format("YYYY-MM-DD") },
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.attendances.length !== 0) {
        this.setState({
          staffAttendance: response.data.attendances,
        });
      }
      const studentResponse = await Axios.get(`${url}/api/student-attendance`, {
        params: { date: moment(new Date()).format("YYYY-MM-DD") },
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (studentResponse.data.attendances.length !== 0) {
        this.setState({
          studentAttendance: studentResponse.data.attendances,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getAttendances();
      }
    }
  };

  render() {
    const { classes } = this.props;
    let staffFiltered = this.state.staffAttendance.filter(
      (data) => data.status === "A" || data.status === "L"
    );
    let studentFiltered = this.state.studentAttendance.filter(
      (data) => data.status === "A" || data.status === "L"
    );
    return (
      <>
        <Grid item xs={12} sm={12} md={5} xl={5} lg={5}>
          <Paper className={classes.paper}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <img
                src={AttendanceIcon}
                alt="Attendance"
                style={{ width: 30, height: 30 }}
              />
              <div style={{ marginLeft: 10, fontSize: 18, fontWeight: "bold" }}>
                Staff Attendance
              </div>
            </div>
            <Divider />
            <div className={classes.body}>
              {staffFiltered.length !== 0 ? (
                <TableContainer>
                  <Table>
                    <CustomTableHeader column={this.state.staffColumn} />
                    <TableBody>
                      {staffFiltered.map((data, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">
                            {data.staffId.fullName}
                          </TableCell>
                          <TableCell align="center">
                            {data.staffId.department}
                          </TableCell>
                          {data.status === "A" && (
                            <TableCell align="center" style={{ color: "red" }}>
                              Absent
                            </TableCell>
                          )}
                          {data.status === "L" && (
                            <TableCell
                              align="center"
                              style={{ color: "orange" }}
                            >
                              Leave
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ flexGrow: 1 }}>
                    Today's attendance hasn't been taken.
                  </div>
                  <Link
                    href="/administration/Staff-Attendance/"
                    color="secondary"
                    style={{ textAlign: "center" }}
                  >
                    Go To Attendance
                  </Link>
                </div>
              )}
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={7} xl={7} lg={7}>
          <Paper className={classes.paper}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <img
                src={AttendanceIcon}
                alt="Attendance"
                style={{ width: 30, height: 30 }}
              />
              <div style={{ marginLeft: 10, fontSize: 18, fontWeight: "bold" }}>
                Student Attendance
              </div>
            </div>
            <Divider />
            <div className={classes.body}>
              {studentFiltered.length !== 0 ? (
                <TableContainer>
                  <Table>
                    <CustomTableHeader column={this.state.studentColumn} />
                    <TableBody>
                      {studentFiltered.map((data, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">
                            {data.studentId.firstName} {data.studentId.lastName}
                          </TableCell>
                          <TableCell align="center">
                            {data.studentId.studentClass}
                          </TableCell>
                          <TableCell align="center">
                            {data.studentId.section}
                          </TableCell>
                          {data.status === "A" && (
                            <TableCell align="center" style={{ color: "red" }}>
                              Absent
                            </TableCell>
                          )}
                          {data.status === "L" && (
                            <TableCell
                              align="center"
                              style={{ color: "orange" }}
                            >
                              Leave
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div>Today's attendance hasn't been taken.</div>
                  <Link
                    href="/administration/Student-Attendance"
                    color="secondary"
                    style={{ textAlign: "center" }}
                  >
                    Go To Attendance
                  </Link>
                </div>
              )}
            </div>
          </Paper>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(DashboardAttendance)));
